/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Email_ToInputs */

const cs_automation_email_to = /** @type {(inputs: Automation_Email_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail příjemce`)
};

const en_automation_email_to = /** @type {(inputs: Automation_Email_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipient email`)
};

/**
* | output |
* | --- |
* | "Recipient email" |
*
* @param {Automation_Email_ToInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_email_to = /** @type {((inputs?: Automation_Email_ToInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Email_ToInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_email_to(inputs)
	return cs_automation_email_to(inputs)
});